import React from 'react';
import { getTenant } from '../../../../Utils/storageUtils';
import { TenantType } from '../../../../Utils/types';
import {
  reversedCategoriesMapping,
  transactionCategoriesLogos,
} from '../../../../Utils/utils';
import { getImagePath } from '../../../../Utils/assetUtils';
import styles from './index.module.css';

const TransactionIcon: React.FC<{
  categoryCode: any;
  category: any;
  merchantLogoCode: any;
  transactionImageBGProp?: any;
  iconSize?: any;
}> = ({
  category,
  categoryCode,
  iconSize,
  merchantLogoCode,
  transactionImageBGProp,
}) => {
  const imageSrc = React.useMemo(() => {
    if (getTenant() === TenantType.PB) {
      return getImagePath(
        `images/categoryIcons/${
          transactionCategoriesLogos[
            categoryCode ?? reversedCategoriesMapping[category.toLowerCase()]
          ]
        }.svg`,
      );
    }

    return `https://logo.ignosis.ai/${merchantLogoCode}.jpg`;
  }, [category, categoryCode, merchantLogoCode]);

  return (
    <div className={`${styles.transactionImageBG} ${transactionImageBGProp}`}>
      <img
        src={imageSrc}
        onError={(e: any) => {
          const img = e.currentTarget;

          if (img.dataset.fallbackApplied) {
            return;
          }
          img.dataset.fallbackApplied = 'true';
          img.src = getImagePath(
            getTenant() === TenantType.SIB
              ? 'images/categoryIcons/sib/OTHERS.svg'
              : 'images/categoryIcons/OTHERS.svg'
          );          
        }}
        className={`${styles.iconSize} ${iconSize}`}
        alt='transaction'
      />
    </div>
  );
};

export default TransactionIcon;
